// extracted by mini-css-extract-plugin
export default {"rating":"StarRating_rating__uHa5q","stars":"StarRating_stars__y5ttd","number":"StarRating_number__llpZt"};